import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { CrsSearchModule } from '../crs-search';
import { ObjectEditComponent } from './object-edit.component';

@NgModule({
    declarations: [ObjectEditComponent],
    imports: [CommonModule, TwcModule, TranslateModule, FormsModule, ReactiveFormsModule, CrsSearchModule],
    exports: [ObjectEditComponent],
})
export class ObjectEditModule {}
